<div class="centered">
  <lucide-icon class="loader" name="loader-circle" [size]="size()" />
  <p class="title">Loading {{title()}}...</p>
</div>